module.exports = __webpack_public_path__ + "static/Banner-18-10dc311d0d88461b91e11135dffaa0b4.png";